module.exports = __webpack_public_path__ + "static/img/product_banner_19_zh.b80685c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_banner_19_zh.png
// module id = sszf
// module chunks = 34